export var DEFAULT_LABEL_SIZE = {
    width: 90,
    height: 20
};